export const ROWS = ['8', '7', '6', '5', '4', '3', '2', '1'];
export const COLS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

export const PIECES = {
  black: ['k', 'q', 'r', 'r', 'b', 'b', 'n', 'n', 'p', 'p', 'p', 'p', 'p', 'p', 'p', 'p'],
  white: ['K', 'Q', 'R', 'R', 'B', 'B', 'N', 'N', 'P', 'P', 'P', 'P', 'P', 'P', 'P', 'P']
};

export const PIECE_NAMES = {
  k: 'King',
  q: 'Queen',
  r: 'Rook',
  b: 'Bishop',
  n: 'Knight',
  p: 'Pawn'
};

export const PLAYER_COLOR = 'white';

export const AI_DIFFICULTIES = ['Beginner', 'Easy', 'Intermediate', 'Advanced', 'Experienced'];

export const MOVE_DELAY_SECS = 1;
export const MOVE_ANIMATION_SECS = 0.9;